import React, { useEffect, useState } from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { Box, Chip } from "@mui/material";
import _without from "lodash/without";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { GetStatusResponse } from "../../models/basicInformation.model";
import { CacheProvider } from "@emotion/react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { prefixer } from "stylis";
import createCache from "@emotion/cache";
import rtlPlugin from "stylis-plugin-rtl";
import { OutlinedInput } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { useQueryClient } from "react-query";
import { IResponse } from "../../models/dropdown.model";
import { useSelector } from "react-redux";

const theme = createTheme({
  direction: "rtl", // Both here and <body dir="rtl">
});
// Create rtl cache
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

interface MultiSelectCmpPropsType {
  // options?: IResponse[];
  options?: any[];
  onChange?: any;
  label?: string;
  value?: any[];
  name?: string;
  id?: string;
  changeMultiSelect?: any;
}

export default function MultiSelectChip(props: MultiSelectCmpPropsType) {
  const initialSelected: string[] | (() => string[]) = [];
  const getValue: string[] | (() => string[]) = props.value!;
  const [multiselectName, setMultiselectName] = React.useState<string[]>(
    initialSelected
  );
  const queryClient = useQueryClient();
  const handleChange = (event: any) => {
    setMultiselectName(event.target.value as string[]);
    props.changeMultiSelect(event.target.value as string[]);
  };
  useEffect(() => {
    setMultiselectName(getValue);
  });
  const handleDelete = (e: React.MouseEvent, value: string) => {
    e.preventDefault();
    props.changeMultiSelect((current: any) => _without(current, value));
    setMultiselectName((current) => _without(current, value));
  };
  const jsonFile = useSelector((state: any) => state.style);
  const css = `
.Mui-selected{
    background: ${jsonFile?.mainColor} !important;
    
}
    .MuiSelect-select{
    margin-top:3px !important;
    }
`;
  return (
    <div>
      <style>{css}</style>
      <CacheProvider value={cacheRtl}>
        <ThemeProvider theme={theme}>
          <div dir="rtl">
            <FormControl fullWidth>
              <InputLabel
                htmlFor="outlined-age-simple"
                color={jsonFile?.muiColor}
                // style={jsonFile?.muiColor === "success" ? {} : { top: "0px" }}
              >
                <span>{props.label}</span>
              </InputLabel>
              <Select
                className="shadowDropDown"
                color={jsonFile?.muiColor}
                // labelId="demo-mutiple-chip-checkbox-label"
                id={props.id}
                fullWidth
                name={props.id}
                multiple
                value={multiselectName}
                onChange={handleChange}
                IconComponent={KeyboardArrowDownIcon}
                input={
                  <OutlinedInput
                    id="select-multiple-chip"
                    label={props.label}
                  />
                }
              >
                {props.options !== null &&
                props.options !== undefined &&
                props.options.length > 0
                  ? props.options.map((name: IResponse) => (
                      <MenuItem key={name.id} value={name.id}>
                        {name.title}
                      </MenuItem>
                    ))
                  : null}
              </Select>
            </FormControl>
          </div>
        </ThemeProvider>
      </CacheProvider>
    </div>
  );
}
